import React from 'react';

import PlanBundle from '~/components/plans/bundles-page/plan-bundle';
import MobileCarousel from '~/components/plans/mobile-carousel';

import styles from '~/components/plans/bundles-page/plan-bundle-page.module.scss';

const MobilePlanCarousel = ({
  animateOnLoad,
  isFlexPay,
  isTablet,
  bundles,
  selectedPlanIndex,
  setSelectedPlanIndex,
  showHardmarkPricing,
  isRecommended,
  showFirstShipmentDate,
  ctaText,
}) => {
  return (
    <div
      className={styles.carouselContainer}
      id="mobile-lawn-plan-card-container"
    >
      <MobileCarousel
        isTablet={isTablet}
        selectedPlanIndex={selectedPlanIndex}
        animateOnLoad={animateOnLoad}
      >
        {bundles.map((bundle, index) => (
          <PlanBundle
            id={`plan-${index}`}
            key={bundle.uuid}
            bundle={bundle}
            onSelect={() => setSelectedPlanIndex(index)}
            isFlexPay={isFlexPay}
            showHardmarkPricing={showHardmarkPricing}
            isRecommended={isRecommended}
            firstShipmentDate={
              showFirstShipmentDate && bundle?.carts?.[0]?.shipDate
            }
            ctaText={ctaText}
          />
        ))}
      </MobileCarousel>
    </div>
  );
};

export default MobilePlanCarousel;
